var getSearchPageCrumbsLinks = function getSearchPageCrumbsLinks(_ref) {
  var selectedOptions = _ref.selectedOptions,
    isYearsPage = _ref.isYearsPage,
    isAuto = _ref.isAuto,
    isCarCountriesPage = _ref.isCarCountriesPage,
    make = _ref.make,
    model = _ref.model,
    year = _ref.year,
    location = _ref.location,
    t = _ref.t,
    createUrl = _ref.createUrl,
    seoH1 = _ref.seoH1;
  function createTagUrl(option) {
    if (isAuto) {
      if (option.filterField === "make_id") {
        return createUrl("/autos/".concat(make === null || make === void 0 ? void 0 : make.trim()));
      }
      if (option.filterField === "model_id") {
        return createUrl("/autos/".concat(make === null || make === void 0 ? void 0 : make.trim(), "/").concat(model === null || model === void 0 ? void 0 : model.trim()));
      }
      return createUrl("/autos/".concat(make === null || make === void 0 ? void 0 : make.trim(), "/").concat(model === null || model === void 0 ? void 0 : model.trim(), "/").concat(year === null || year === void 0 ? void 0 : year.trim()));
    }
    if (option.filterField === "year") {
      return createUrl("/years/".concat(year === null || year === void 0 ? void 0 : year.trim()));
    }
    if (option.filterField === "make_id") {
      return createUrl("/years/".concat(year === null || year === void 0 ? void 0 : year.trim(), "/").concat(make === null || make === void 0 ? void 0 : make.trim()));
    }
  }
  var crumbs = [];
  if (isCarCountriesPage) {
    // Car Countries page breadcrumb

    if (seoH1) {
      crumbs.push({
        title: seoH1
      });
    }
  } else if (isYearsPage) {
    // Years page breadcrumb
    if (location.pathname === "/years") {
      crumbs.push({
        title: t("years", {
          ns: "web_search"
        })
      });
    } else {
      crumbs.push({
        title: t("years", {
          ns: "web_search"
        }),
        link: createUrl("/years")
      });
    }
    selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.sort(function (a, b) {
      if (a.filterField === "year") {
        return -1;
      } else if (b.filterField === "year") {
        return 1;
      }
      return 0;
    }).forEach(function (option) {
      if (createTagUrl(option) !== location.pathname) {
        crumbs.push({
          title: option.type === "range" ? option.range_values.from : option.name,
          link: createTagUrl(option)
        });
      } else {
        crumbs.push({
          title: option.type === "range" ? option.range_values.from : option.name
        });
      }
    });
  } else {
    // Autos breadcrumb
    if (location.pathname === "/autos" && isAuto) {
      crumbs.push({
        title: t("cars_2", {
          ns: "web_search"
        })
      });
    } else {
      crumbs.push({
        title: t("cars_2", {
          ns: "web_search"
        }),
        link: createUrl("/autos")
      });
    }
    selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.forEach(function (option) {
      if (createTagUrl(option) !== location.pathname && (option === null || option === void 0 ? void 0 : option.facetName) !== "year") {
        crumbs.push({
          title: option.type === "range" ? option.range_values.from : option.name,
          link: createTagUrl(option)
        });
      } else {
        crumbs.push({
          title: option.type === "range" ? option.range_values.from : option.name
        });
      }
    });
  }
  return crumbs;
};
export default getSearchPageCrumbsLinks;